// Message card shell for plan / changes / summary cards in chat (SPEC §3).
//   <MessageCard head="TODAY · TUESDAY, NOV 10" indent>
//     <MessageRow time="9:30 AM" title="Q3 report: write the next part" side="25 min" />
//     ...actions
//   </MessageCard>
import type { ComponentChildren, JSX } from 'preact';
import s from './MessageCard.module.css';

export interface MessageCardProps {
  head?: string;
  /** Indent under the buddy's face column (36px) like chat cards. */
  indent?: boolean;
  /** Variant: card (default) | note (lighter, e.g. "Your streak is safe") | dashed (accent dashed border, "FIRST ON TOMORROW'S LIST"). */
  variant?: 'card' | 'note' | 'dashed';
  anim?: string;
  children?: ComponentChildren;
  class?: string;
  style?: JSX.CSSProperties;
}

export function MessageCard({ head, indent, variant = 'card', anim, children, class: cls, style }: MessageCardProps) {
  return (
    <div class={[s.card, s[variant], indent && s.indent, cls].filter(Boolean).join(' ')} style={{ animation: anim, ...style }}>
      {head && <p class={s.head}>{head}</p>}
      {children}
    </div>
  );
}

export interface MessageRowProps {
  time: string;
  title: string;
  side?: string;
  /** Struck-through title (moved card). */
  strike?: boolean;
  dim?: boolean;
  /** Side text in accent (e.g. "Done", "Tomorrow"). */
  sideAccent?: boolean;
}
export function MessageRow({ time, title, side, strike, dim, sideAccent }: MessageRowProps) {
  return (
    <div class={s.row}>
      <span class={s.time}>{time}</span>
      <span class={s.title} style={{ textDecoration: strike ? 'line-through' : undefined, color: dim || strike ? '#B9B2A6' : undefined }}>{title}</span>
      {side && <span class={s.side} style={{ color: sideAccent ? 'var(--acc)' : undefined }}>{side}</span>}
    </div>
  );
}
